import styled, {css} from "styled-components"

import Icon from "@irati/ui/src/Icon"
import {greys} from "@irati/ui/src/global/colors"
import Flex from "@irati/ui/src/Flex"

export const InverseGeoPin = styled(Icon).attrs({
  color: greys.white
})`
  stroke: ${greys.black};
  flex: 0 0 auto;
`

export const Number = styled.div`
  ${({theme}) => css`
    color: ${theme.colors.utility.white};
    background-color: ${theme.colors.perkbox.blue};
    font-family: ${theme.font.bold};
  `}
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  font-size: 14px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
`

export const Container = styled(Flex)`
  ${Number} {
    margin-right: 10px;
  }

  ${InverseGeoPin} {
    margin: ${({theme}) => `${theme.spacing.one} ${theme.spacing.half} 0 0`}
  }
`

export const Text = styled.div`
  line-height: 1;
  flex: 1 1 auto;
`
